import { makeStyles } from "@mui/styles";

export default makeStyles((theme) => ({
  btnPrimary: {
    background: theme?.palette?.primary2TextColor?.main,
    borderRadius: "5px",
    padding: "6px 20px",
    color: theme?.palette?.primaryText?.[100],
    height: "36px",
    fontSize: "12px",
    fontWeight: "600",
    textTransform: "capitalize",
    marginRight: "10px",
    [theme.breakpoints.down("md")]: {
      padding: "6px 10px",
      height: "30px",
      fontSize: "10px"
    },
    "&:hover": {
      background: theme?.palette?.secondaryBG?.mains
    },
    "& span": {
      marginRight: "5px"
    }
  },

  dialogcontainer: {
    maxWidth: "95%",
    margin: "30px auto",
    "& .MuiDialog-container": {
      display: "block"
    },
    "& .MuiDialogContent-root, .MuiPaper-root": {
      background: "transparent",
      [theme.breakpoints.down("sm")]: {
        marginTop: "0px"
      }
    }
  },

  searchField: {
    width: "100%",
    backgroundColor: theme?.palette?.primaryBG?.[400],
    cursor: "pointer",
    height: "10%",
    padding: "9px 10px",
    color: theme?.palette?.primaryText?.[200],
    borderRadius: "10px",
    [theme.breakpoints.down("sm")]: {
      padding: "10px 10px",
      fontSize: "0.74rem"
    }
  },

  searchIcon: {
  width: "40px",
  height: "40px",
  borderRadius: "10px",
  background: theme?.palette?.secondaryBG?.red,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",

  "& svg": {
    color: theme?.palette?.secondaryText?.[700]
  },

  [theme.breakpoints.down("sm")]: {
    width: "40px",
    height: "40px",

    "& img, svg": {
      width: "15px",
      height: "15px"
    },

    "& button": {
      minHeight: "40px",
      minWidth: "40px"
    }
  }
}
}));
